import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ActionsButtons } from "../../../providers/service/open-dialog.service";

@Component({
    selector: 'app-show-raw-detail',
    templateUrl: './show-raw-detail.component.html',
    styleUrls: ['./show-raw-detail.component.scss'],
    standalone: false
})
export class ShowRawDetailComponent implements OnInit {
    valuesToRemove = [];

    constructor(public dialogRef: MatDialogRef<ShowRawDetailComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            title?: string,
            subTitle?: string,
            values: {
                title: { traduction?: string, sensorTraduction?: string, value?: any },
                subTitle: { traduction?: string, sensorTraduction?: string, value?: any },
                value: { traduction?: string, sensorTraduction?: string, value?: any }
            }[],
            resizeClass: string,
            actions: ActionsButtons[],
            removeValues: boolean
        }) {

    }

    ngOnInit(): void {
    }

    get resizeClass(): string {
        return this.data.resizeClass;
    }

    get values(): {
        title: { traduction?: string, value?: any, sensorTraduction?: string },
        subTitle: { traduction?: string, value?: any, sensorTraduction?: string },
        value: { traduction?: string, sensorTraduction?: string, value?: any }
    }[] {
        return this.data.values;
    }

    get titleDialog(): string | undefined {
        return this.data.title;
    }

    removeValue(index: number) {
        this.data.values.splice(index, 1)
    }

    sendValue() {
        this.dialogRef.close(this.data.values);
    }
    clickAction(action: ActionsButtons) {
        this.dialogRef.close({ action });
    }

    closeDialog() {
        this.dialogRef.close(undefined)
    }
}
